import React, {Component} from 'react';
import MiniButton from "../MiniButton";
import Alert from "react-s-alert";
import DefaultModal from "../../accounting/invoice/DefaultModal";
import {request} from "../../helper/APIUtils";
import {showAxiosError} from "../../helper/helper";
import SweetAlert from "react-bootstrap-sweetalert";
import ReactLoading from "react-loading";
import {Col, Collapse, FormGroup, Row} from "reactstrap";
import SearchField from "./SearchField";
import {eCommerces} from "../../helper/enums";


class DetailedSearch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchQuery: undefined,
            collapse: false,
            fields: [],
            fieldsAndValues: {},
            key: 'sj2hj3hsj2hsh3j2',
            value: '',
            isMobile: window.innerWidth > 991 ? false : true,
            searchList: [],
            newSearchArray: [],
            showSaveModal: false,
            loading: false,
            searchName: null,
            selectedRecordId: null,
            multipleVknTckn: null
        };

        this.clearAll = this.clearAll.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.onFieldChange = this.onFieldChange.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.toggleCollapse = this.toggleCollapse.bind(this);
        this.onSaveSearch = this.onSaveSearch.bind(this);
        this.handleSaveSearch = this.handleSaveSearch.bind(this);
        this.selectProperty = this.selectProperty.bind(this);
        this.openDeleteRowModal = this.openDeleteRowModal.bind(this);
        this.removeRow = this.removeRow.bind(this);
        this.onChangeSearchName = this.onChangeSearchName.bind(this);
        this.fetchSavedSearch = this.fetchSavedSearch.bind(this);
        this.saveSearch = this.saveSearch.bind(this);
        this.checkIfSearchTitleExists = this.checkIfSearchTitleExists.bind(this);
    }

    componentDidMount() {
        if (this.props.fields && !(document.body.outerHTML.includes('modal-body'))) {
            this.setSearchFieldsVisibility();
        }
    }

    fetchSavedSearch() {
        let filterType = this.props.filterType;
        let self = this;
        let params = {
            url: `/searchLog/getSearchLogs?filterType=${filterType}`,
            method: "get",
        };
        this.setState({loading: true});
         request(params)
            .then(response => {
                self.setState({searchList: response.data, loading: false});
            }).catch(error => {
                self.setState({loading:false});
            });
    }

    componentWillMount() {
        let fieldsAndValues = {};
        this.props.fields.map(field => {
            fieldsAndValues[field.accessor] = {
                value: undefined,
                operator: field.operator,
                type: field.type,
                onOther: field.onOther
            }
        });
        this.setState({fieldsAndValues})
    }

    clearAll() {
        let fieldsAndValues = {};
        this.props.fields.map(field => {
            if (field.accessor === "city") {
                fieldsAndValues[field.accessor] = {
                    value: undefined,
                    operator: field.operator,
                    onOther: field.onOther,
                    type: field.type
                }
            } else {
                fieldsAndValues[field.accessor] = {value: undefined, operator: field.operator, type: field.type}
            }
        });

        this.setState({
            fieldsAndValues,
            searchQuery: undefined,
            key: Math.random(),
            collapse: !this.state.collapse,
            newSearchArray: [],
            searchName: null,
            selectedRecordId: null,
            multipleVknTckn:null
        })
    }

    async saveSearch(searchQuery, searchName, selectedRecordId) {
        let self = this;
        searchQuery = !searchQuery ? '' : ' ' + searchQuery;
        try{
            let checked = await this.checkIfSearchTitleExists();
            if (checked) {
                let params = {
                    url: '/searchLog/saveSearchLog',
                    method: "post",
                    data: {
                        filterType: this.props.filterType,
                        recordId: selectedRecordId,
                        searchQuery,
                        searchName
                    }
                };
                self.setState({loading: true});
                request(params)
                    .then(function (response) {
                        Alert.success("Kaydetme işlemi başarılı.", {
                            position: 'top-right',
                            effect: 'stackslide',
                            timeout: 2000
                        });
                        self.setState({
                            showSaveModal: false,
                            searchQuery: null,
                            searchName: null,
                            selectedRecordId: null,
                            loading: false
                        }, () => self.fetchSavedSearch());
                    }).catch(function (error) {
                    showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
                });
            } else if(searchName == null) {
                Alert.error('Aramanın Adı alanı boş olamaz.', {
                    html: true,
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
            }else{
                Alert.error('Aynı adlı arama kaydı zaten mevcut.', {
                    html: true,
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                })
            }
        }catch(error){
        }

    }

    selectProperty(row) {
        let newSearchArray = [];
        this.setState({newSearchArray});
        if (!!row.property) {
            let properties = row.property.split("&").map((content, key) => {
                let title = content.split("=")[0];
                let value = content.split("=")[1];
                newSearchArray.push({key: title, value: value});
            });

            let operation = this.props.fields.map((content, i) => {
                let temp = newSearchArray.find(function (element) {
                    if(/\s/.test(element.key)){
                        element.key = element.key.replace(/\s/g, '');
                    }
                    if(/\s/.test(content.accessor)){
                        content.accessor = content.accessor.replace(/\s/g, '');
                    }
                    return element.key === content.accessor;
                });
                if (temp !== undefined && temp.key) {
                    content.value = temp.value;
                } else {
                    content.value = undefined;
                }
                return content;
            });

            this.props.fields.map(field => {
                this.onFieldChange(field.accessor, field.value, field.type);
            });

            this.setState({
                newSearchArray: operation,
                key: Math.random(),
                collapse: !this.state.collapse,
                selectedRecordId: row.recordId,
                searchName: row.title
            })

        } else {
            this.setState({newSearchArray: []}, () => this.clearAll())
        }
    }

    handleSaveSearch() {
        let searchQuery = this.serializeFields();
        if (!!searchQuery || searchQuery !== "") {
            this.setState({showSaveModal: true});
        } else {
            Alert.error('Boş alanları doldurunuz.', {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000,
                html: false
            });
        }
    }

    onSaveSearch() {
        //DefaultModal
        let searchQuery = this.serializeFields();
        let searchQueryWithoutAbsent = this.serializeFieldsWithoutAbsent();
        this.setState({
            searchQuery,
        }, () => this.saveSearch(searchQueryWithoutAbsent, this.state.searchName, this.state.selectedRecordId));
    }

    openDeleteRowModal(row) {
        this.setState({
            alert: (
                <SweetAlert showCancel warning
                            confirmBtnText="Evet"
                            cancelBtnText="Hayır"
                            confirmBtnBsStyle="danger"
                            cancelBtnBsStyle="default"
                            title="Emin Misiniz?"
                            onConfirm={() => this.removeRow(row)}
                            onCancel={() => this.setState({alert: null})}
                >
                    {row.title + " işlemi silinecek, onaylıyor musunuz?"}
                </SweetAlert>
            )
        })
    }

    removeRow(row){
        if (!!row) {
            let params = {
                url: `/searchLog/removeSearchLog`,
                method: 'post',
                data: row.recordId
            };
            request(params).then(() => {
                this.setState({alert: null},() => this.fetchSavedSearch());
                Alert.success("İşlem başarıyla silindi.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
            }).catch(function (error) {
                showAxiosError(error);
            });
        }
    }


    handleSearch() {
        let searchQuery = this.serializeFields();
        if(this.state.multipleVknTckn != null){
            this.setState({searchQuery, loading: true}, () => this.props.onSearch(this.state.searchQuery, this.state.multipleVknTckn))
        }else{
            if (this.props.type === eCommerces.TRENDYOL) {
                // if (this.state.fieldsAndValues.orderNumber?.value !== undefined &&
                //     (this.state.fieldsAndValues.status?.value === undefined || this.state.fieldsAndValues.status?.value === null)) {
                //     return Alert.error("Sipariş Durumu Giriniz", {
                //         position: 'top-right',
                //         effect: 'stackslide',
                //         timeout: 5000,
                //         html: false
                //     });
                // }
                if ((this.state.fieldsAndValues.endDate?.value !== undefined &&
                        this.state.fieldsAndValues.startDate?.value === undefined) ||
                    (this.state.fieldsAndValues.endDate?.value === undefined &&
                        this.state.fieldsAndValues.startDate?.value !== undefined)) {
                    return Alert.error("Tarih Aralığı Giriniz.", {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 5000,
                        html: false
                    });
                }
            }
            this.setState({searchQuery, loading: true}, () => this.props.onSearch(this.state.searchQuery))
        }
    }

    onFieldChange(fieldName, value, type) {
        let {fieldsAndValues} = this.state;
        if(typeof value === 'number' || (type === "select" && ((fieldName !== "city" && fieldName !== "taxOffice") || fieldName === "status")) || type === 'timestamp'){
            fieldsAndValues[fieldName].value = value;
        }else if(type === "textArea"){
            fieldsAndValues[fieldName].value = value;
            this.setState({multipleVknTckn: value});
        }
        else
            fieldsAndValues[fieldName].value = (value ? value.toLocaleLowerCase('tr-TR') : value);

        if (fieldName === "city") {
            fieldsAndValues[fieldName].onOther(value);
        }

        if (this.props.from &&
            (("tmpBelgeList" === this.props.from && ("min_issueDate" === fieldName || "max_issueDate" === fieldName)) ||
                ("sanalBaBsList" === this.props.from && "issueDate" === fieldName) ||
                ("eInvoiceInbox" === this.props.from && "chemistWarehouseFilter" === fieldName) ||
                ("creditPoolList" === this.props.from && "creditPoolType" === fieldName))) {
            this.props.onFieldValueChange(fieldName, value);
        }

        this.setState({fieldsAndValues});
       if(this.props.changeFieldValue) this.props.changeFieldValue(fieldName, value);
    }

	serializeFields() {
		let serializedFields = "";
		let fieldsAndValues = this.state.fieldsAndValues;
		let fields = this.props.fields;

        let absentValueControlMap = {}

        //it's assumed and asserted at mount time that (TODO:assert)
        // - max_xx can't precede min_xx of same accessor,
        // - there must only 1 max_xx,min_xx pair,
        for (let i in fields) {
            const accessor = fields[i].accessor
            if (fieldsAndValues[accessor] !== undefined && (fieldsAndValues[accessor].operator === '<=' && !!fieldsAndValues[accessor].value)) { //max is defined
                const min_equivalentField = fieldsAndValues[`min_${this.correctFieldName(accessor)}`]
                if (!!min_equivalentField && !min_equivalentField.value) { //min_xx equivalent of same field accessor is defined and has no value
                    absentValueControlMap[this.correctFieldName(accessor)] = true //value of min_equivalent is ABSENT, hence the absentValueControlMap
                }
            }
        }

		for (let field in fieldsAndValues) {
			if (!!fieldsAndValues[field].value && serializedFields.length > 0) {
				serializedFields += "&";
			}
			if (fieldsAndValues[field].operator !== '>=' && fieldsAndValues[field].operator !== '<=') {
				if (!!fieldsAndValues[field].value) {
					if (!(this.props.from && "sanalBaBsList" === this.props.from && "issueDate" === field)) {
						serializedFields += `${field}${fieldsAndValues[field].operator}${(fieldsAndValues[field].value + '').trim()}`
					}
				}
			} else {
				const correctFieldName = this.correctFieldName(field)
				if (fieldsAndValues[field].operator === '>=') { //min
					if (absentValueControlMap[this.correctFieldName(field)]) { //minvalue absent and max exists. pass 0000-00 as min val
						if (serializedFields.length > 0)
							serializedFields += "&";
						const fieldType = fieldsAndValues[field].type;
						if (fieldType === 'date')
							serializedFields += `${correctFieldName}=0001-01-01`
						else if (fieldType === 'datetime' || fieldType === 'timestamp')
							serializedFields += `${correctFieldName}=0001-01-01 00:00:00`
						else if (fieldType === 'month')
							serializedFields += `${correctFieldName}=0001-01`
						else //number assumed. add custom fields as you like. (-99 etc., remember to customize the repository as well. [wait, I'm talking to myself <.< ])
							serializedFields += `${correctFieldName}=0`
					} else { // min value exists. just convert '>=' to '='
						if (!!fieldsAndValues[field].value)
							serializedFields += `${correctFieldName}=${fieldsAndValues[field].value.trim()}`
					}
				} else { //max value, just convert '<=' to '='
					if (!!fieldsAndValues[field].value)
						serializedFields += `${correctFieldName}=${fieldsAndValues[field].value.trim()}`
				}
			}
		}
		if (this.props.type !== undefined && this.props.type === eCommerces.CICEKSEPETI) {
			return this.state.fieldsAndValues;
		} else {
			return serializedFields;
		}
	}

    serializeFieldsWithoutAbsent() {

        let serializedFields = "";
        let fieldsAndValues = this.state.fieldsAndValues;

        for (let field in fieldsAndValues) {
            if(fieldsAndValues[field] !== undefined){
                if (!!fieldsAndValues[field].value && serializedFields.length > 0) {
                    serializedFields += "&";
                }
                if (fieldsAndValues[field].operator !== '>=' && fieldsAndValues[field].operator !== '<=') {
                    if (!!fieldsAndValues[field].value) {
                        if (!(this.props.from && "sanalBaBsList" === this.props.from && "issueDate" === field)) {
                            serializedFields += `${field}${fieldsAndValues[field].operator}${(fieldsAndValues[field].value + '').trim()}`
                        }
                    }
                } else {
                    if (fieldsAndValues[field].operator === '>=') { //min
                        if (!!fieldsAndValues[field].value)
                            serializedFields += `${field}=${fieldsAndValues[field].value.trim()}`
                    } else { //max value, just convert '<=' to '='
                        if (!!fieldsAndValues[field].value)
                            serializedFields += `${field}=${fieldsAndValues[field].value.trim()}`
                    }
                }
            }
        }

        return serializedFields
    }

    correctFieldName(fieldName) {
        //split 2 times to obtain correct field name : e.g.: receivedDate -> ["","receivedDate"], and the [1]st element is "receivedDate"
        let splitted = fieldName.split(/min_|max_/);
        if (splitted.length === 1) {
            return splitted[0]
        } else {
            return splitted[1]
        }
    }

    handleKeyPress(event) {
        if (event.key === 'Enter') {
            this.handleSearch();
        }
    }

    toggleCollapse(e) {
        this.setState(state => ({collapse: !state.collapse}));

        if (this.props.toggle) {
            this.props.toggle(e);
        }

        setTimeout(() => {
            this.setSearchFieldsVisibility();
        }, 50);
    }

    setSearchFieldsVisibility = () => {
        let searchFields = this.props.hasContainer ?
            document.querySelectorAll(`#${this.props.hasContainer} .singleSearchField`) :
            document.querySelectorAll('.singleSearchField');
        let searchFieldsLength = searchFields.length;

        if (searchFieldsLength > 6) {

            if (this.state.collapse) {
                for (let i = 0; i < searchFieldsLength; i++) {
                    searchFields[i].style.display = "block";
                }
            } else {
                for (let i = 6; i < searchFieldsLength; i++) {
                    searchFields[i].style.display = "none";
                }
            }
        }
    }

    setInitialValue(value) {
        if (value)
            return value;
        else
            return '';
    }

    onChangeSearchName(e) {
        let name = e.target.name;
        let value = e.target.value;
        this.setState({[name]: value});
    }

     async checkIfSearchTitleExists() {
        let self = this;
        if(self.state.searchName !== null){
            let data = {
                title: self.state.searchName,
                filterType: self.props.filterType,
                recordId: self.state.selectedRecordId
            };
            let params = {
                url: `/searchLog/findBySearchTitle`,
                method: 'post',
                data: data,
            };
            return request(params).then(response => {
                if (response.data) {
                    return Promise.resolve(response.data);
                }
            }).catch(error => {
                showAxiosError(error);
                return Promise.resolve(false);
            });
        }else{
            return Promise.resolve(false);
        }

    }

    render() {
        const {isMobile} = this.state;
        return (
            <div style={{marginBottom: '15px'}}>
                {this.state.alert}
                <div className="detailedSearchContainer" key={this.state.key}
                     style={{border: '1px solid', padding: '5px 10px 3px', borderRadius: '5px'}}>
                    {this.props.fields && this.props.fields.length > 6 &&
                        <FormGroup onClick={e => this.toggleCollapse(e)}>
                            <div style={{
                                margin: '-5px -9px 5px',
                                background: '#8faab9',
                                borderRadius: '5px 5px 0 0',
                                textAlign: "end",
                                height: '30px',
                                paddingTop: '2px'
                            }}>
                                {this.state.searchName && this.state.searchName !== null &&
                                    <div style={{float: "left", marginLeft: "12px"}}>
                                        <h4 style={{fontSize: '1.2em', color: "white", margin: "0"}}>Seçilen
                                            Filtre: {this.state.searchName}
                                        </h4>
                                    </div>
                                }
                                <button type="button"
                                        className="close pull-right"
                                        style={{
                                            outline: "none",
                                            fontSize: "xx-large",
                                            marginRight: "4px",
                                            marginTop: "-6px",
                                            marginLeft: "1%"
                                        }}
                                        title={!this.state.collapse ? "Aramayı Göster" : "Aramayı Gizle"}>
                                <span style={{fontSize: "x-large", border: "none"}} aria-hidden="true">
                                    <i className={!this.state.collapse ? "fas fa-angle-down" : "fas fa-angle-up"}
                                       style={{fontSize: "smaller", color: 'white', padding: '0 10px'}}/>
                                </span>
                                </button>
                                <h4 style={{fontSize: '1.2em', color: "white"}}>Gelişmiş Arama</h4>
                            </div>
                        </FormGroup>}

                    <Row style={{padding: '0 2%'}}>
                        {(this.state.newSearchArray && this.state.newSearchArray.length > 0) ?
                            this.state.newSearchArray.map((searchField, i) => {
                                    return (
                                        <Col sm='12' md='4' className="singleSearchField">
                                            <SearchField key={i} operator={searchField.operator}
                                                         onKeyPress={this.handleKeyPress}
                                                         type={searchField.type}
                                                         accessor={searchField.accessor}
                                                         label={searchField.label}
                                                         selectData={searchField.selectData}
                                                         listener={this.onFieldChange}
                                                         path={searchField.path}
                                                         initialValue={this.setInitialValue(searchField.value)}
                                                         disableAccessibleDate={searchField.disableAccessibleDate}
                                                         searchType="savedSearch"
                                            />
                                        </Col>
                                    )
                                }
                            )
                            :
                            this.props.fields.map((searchField, i) => {
                                    return (
                                        <Col sm='12' md='4' className="singleSearchField">
                                            <SearchField key={i} operator={searchField.operator}
                                                         onKeyPress={this.handleKeyPress}
                                                         type={searchField.type}
                                                         accessor={searchField.accessor}
                                                         label={searchField.label}
                                                         selectData={searchField.selectData}
                                                         listener={this.onFieldChange}
                                                         path={searchField.path}
                                                         initialValue={this.setInitialValue(searchField.initialValue)}
                                                         disableAccessibleDate={searchField.disableAccessibleDate}
                                                         searchType="defaultSearch"
                                            />
                                        </Col>
                                    )

                                }
                            )
                        }
                    </Row>

                    <div style={
                        !isMobile ? {
                                display: 'flex',
                                flexDirection: 'column',
                                borderRadius: '5px',
                                background: '#dedede',
                                margin: '5px 0'
                            } :
                            {
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'center',
                                background: '#dedede',
                                margin: '5px 0',
                                borderRadius: '5px',
                            }
                    }>
                        <div style={!isMobile ? {flexDirection: 'row', padding: '5px 10px'} : {
                            display: 'flex',
                            flexDirection: 'row',
                            padding: '5px 10px'
                        }}>
                            {this.props.filterSearch &&
                                <div style={{float: "left"}}>
                                    <button type="button" data-toggle="tooltip" data-placement="bottom"
                                            style={!isMobile ? {
                                                    background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                                    marginLeft: '9px'
                                                } :
                                                {
                                                    background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                                    letterSpacing: 'unset'
                                                }}
                                            rel="tooltip" className="TekBtn kaydet btn-icon"
                                            onClick={e => {
                                                this.handleSaveSearch()
                                            }}>FİLTRELEMEYİ KAYDET
                                    </button>
                                    <button type="button" data-placement="bottom"
                                            style={!isMobile ? {background: '#72bdd4', marginLeft: '9px'} :
                                                {background: '#72bdd4', letterSpacing: 'unset'}}
                                            rel="tooltip" className="TekBtn filter btn-icon"
                                            data-toggle="dropdown"
                                            id="dropdownMenuButton"
                                            onClick={(e) => this.fetchSavedSearch()}
                                    >FİLTRELEMEYİ LİSTELE
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-right"
                                         style={{maxWidth: "200px", maxHeight: "300px", marginLeft: "130px"}}
                                         aria-labelledby="dropdownMenuButton">
                                        {(this.state.searchList !== null && this.state.searchList.length > 0) ?
                                            this.state.searchList.map((row, i) =>
                                                <li style={{overflow: "hidden"}}>
                                                    <Row>
                                                        <Col sm={8}>
                                                            <a className="dropdown-item" title={row.title}
                                                               onClick={() => this.selectProperty(row)} style={{
                                                                cursor: "pointer",
                                                                fontWeight: 'bold',
                                                                display: 'block',
                                                                width: '150px',
                                                                overflow: 'hidden',
                                                                whiteSpace: 'nowrap',
                                                                textOverflow: 'ellipsis'
                                                            }}>{row.title}&nbsp;&nbsp;
                                                            </a>
                                                        </Col>
                                                        <Col sm={2}>
                                                            <MiniButton title="Sil" faIcon="fa-trash" color="danger"
                                                                        onClick={() => this.openDeleteRowModal(row)}/>
                                                        </Col>
                                                    </Row>
                                                </li>
                                            ) : (this.state.loading ? <ReactLoading type="spinningBubbles" style={{
                                                    width: "30px",
                                                    height: "50px",
                                                    margin: "20px 70px 8px",
                                                    fill: "#888"

                                                }}/>
                                                :
                                                <li style={{overflow: "hidden"}}>
                                                    <a className="select-menu-outer">Sonuç Bulunamadı</a>
                                                </li>)
                                        }
                                    </div>
                                </div>
                            }
                            <div style={{float: "right", marginRight: "15px"}}>
                                <button type="button" data-toggle="tooltip" data-placement="bottom"
                                        style={!isMobile ? {background: 'rgb(243, 157, 157)', marginLeft: '9px'} :
                                            {background: 'rgb(243, 157, 157)', letterSpacing: 'unset'}}
                                        rel="tooltip" className="TekBtn lightred delete btn-icon"
                                        onClick={this.clearAll}>Tümünü Temİzle
                                </button>
                                <button type="button" data-toggle="tooltip" data-placement="bottom"
                                        style={!isMobile ? {
                                                background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                                marginLeft: '9px'
                                            } :
                                            {
                                                background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                                letterSpacing: 'unset'
                                            }}
                                        rel="tooltip"
                                        className="TekBtn lightgreen search btn-icon pull-right"
                                        onClick={this.handleSearch}>Arama Yap
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {this.state.showSaveModal &&
                    <DefaultModal
                        isOpen={this.state.showSaveModal}
                        title={"Arama Kaydet"}
                        confirmBtnText="Kaydet"
                        cancelBtnText="Kapat"
                        onConfirm={this.onSaveSearch}
                        onCancel={(e) => this.setState({showSaveModal: false, searchName:null})}
                    >
                        <div className="row"
                             style={{marginTop: 20, marginBottom: 20, position: 'relative', alignItems: 'center'}}>
                            <div className="col-12">
                                <label className="col-form-label" style={{fontSize: "14px", fontWeight: "bold"}}>Aramanın
                                    adı: </label>
                                <input className="form-control"
                                       type="text"
                                       onChange={this.onChangeSearchName}
                                       value={this.state.searchName || ""}
                                       name="searchName"/>
                            </div>
                        </div>
                    </DefaultModal>
                }

            </div>
        )
    }
}

export default DetailedSearch;